import React, { useEffect } from 'react';
import {
    Checkbox,
    FormControlLabel,
    Grid,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
    updateEndorsementFormData,
    selectEndorsmentFormData,
} from 'src/features/rfqDataSlice';

const FireFloaterSelection = ({
    sectionId,
    fireFloaterData,
    updateSection
}) => {
    const dispatch = useDispatch();
    const endorsementFormData = useSelector(selectEndorsmentFormData);

    const allSections =
        endorsementFormData?.sumInsuredSectionData || {};

    const currentSection =
        allSections?.[sectionId] || {};

    const currentFloater =
        currentSection?.fireFloaterData || null;

    // ✅ Initialize only once (safe merge)
    useEffect(() => {
        if (!currentFloater) {           
        //    updateSection?.();
        }
    }, []);

    const handleChange = (key, checked) => {
        const latestSection =
            endorsementFormData?.sumInsuredSectionData?.[sectionId] || {};

        const latestFloater =
            latestSection?.fireFloaterData || {};

        dispatch(
            updateEndorsementFormData({
                sumInsuredSectionData: {
                     ...endorsementFormData.sumInsuredSectionData,
                    [sectionId]: {
                        ...latestSection, // preserves selectedRows + others
                        fireFloaterData: {
                            ...latestFloater,
                            [key]: checked,
                        },
                    },
                },
            })
        );
    };

    const floater =
        endorsementFormData?.sumInsuredSectionData?.[sectionId]
            ?.fireFloaterData || {};

    return (
        <Grid container spacing={2} sx={{ pl: 0 }}>
            <Grid item xs={6}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={
                                floater?.isfireFloaterOccupancySelected || false
                            }
                            onChange={(e) =>
                                handleChange(
                                    'isfireFloaterOccupancySelected',
                                    e.target.checked
                                )
                            }
                        />
                    }
                    label={`Occupancy : ${floater?.fireFloaterOccupancy || ''
                        }`}
                />
            </Grid>

            <Grid item xs={6}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={
                                floater?.istotalSumInsuredSelected || false
                            }
                            onChange={(e) =>
                                handleChange(
                                    'istotalSumInsuredSelected',
                                    e.target.checked
                                )
                            }
                        />
                    }
                    label={`Total Sum Insured : ${floater?.totalSumInsured || ''
                        }`}
                />
            </Grid>
        </Grid>
    );
};

export default FireFloaterSelection;